// src/components/WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';
import whatsappLogo from '../assets/images/whatsapp.webp'; // <--- IMPORT YOUR WEBP IMAGE HERE

const WhatsAppButton = ({ phoneNumber, message }) => {
    // Construct the WhatsApp link
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappLink}
            className="whatsapp-button"
            target="_blank" // Opens in a new tab/window
            rel="noopener noreferrer" // Security best practice for target="_blank"
            aria-label="Chat with us on WhatsApp"
        >
            {/* Replace the SVG with your image */}
            <img src={whatsappLogo} alt="WhatsApp" className="whatsapp-icon-img" /> {/* <--- NEW IMAGE TAG */}
        </a>
    );
};

export default WhatsAppButton;